import MicroModal from 'micromodal';

// Fotka z galerie se otevře v modalu (Micromodal) spolu s názvem projektu,
// technologií a odkazem na projekt z data-* atributů odkazu
export default class GalleryModal {
    static readonly MODAL_ID = 'gallery-modal';

    static init(): void {
        const modal: HTMLElement | null = document.getElementById(this.MODAL_ID);
        const triggers: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('[data-gallery-modal-trigger]');

        if (!modal || triggers.length === 0) {
            return;
        }

        const image = modal.querySelector('[data-gallery-modal-image]') as HTMLImageElement | null;
        const title = modal.querySelector('[data-gallery-modal-title]') as HTMLElement | null;
        const technology = modal.querySelector('[data-gallery-modal-technology]') as HTMLElement | null;
        const link = modal.querySelector('[data-gallery-modal-link]') as HTMLAnchorElement | null;

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();

                if (image) {
                    image.src = trigger.href;
                    image.alt = trigger.dataset.title ?? '';
                }

                if (title) {
                    title.textContent = trigger.dataset.title ?? '';
                }

                if (technology) {
                    technology.textContent = trigger.dataset.technology ?? '';
                }

                if (link) {
                    link.href = trigger.dataset.link ?? '#';
                }

                MicroModal.show(this.MODAL_ID, {
                    disableScroll: true,
                    awaitOpenAnimation: true,
                    awaitCloseAnimation: true,
                });
            });
        });
    }
}
